import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const PlaidLogo: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      {...iconAccessibility(accessibilityLabel)}
      width={24}
      height={24}
      fill='none'
    >
      <path
        fill='#111'
        d='M24 12a12 12 0 01-12 12A12 12 0 010 12a12 12 0 0124 0z'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M10.861 6.5l-3.405.891-.938 3.424 1.173 1.205L6.5 13.205l.883 3.438 3.39.947 1.192-1.185 1.173 1.204 3.405-.891.938-3.424-1.173-1.204 1.192-1.185-.883-3.438-3.39-.947-1.192 1.185L10.861 6.5zM8.772 8.05l1.793-.47.784.805-1.144 1.137L8.772 8.05zm3.937.346l.797-.791 1.786.498-1.457 1.448-1.125-1.155zm-5.115 2.138l.493-1.803 1.433 1.472-1.143 1.137-.784-.805zm6.915-.291l1.457-1.448.465 1.812-.797.791-1.125-1.155zm-3.628-.029l1.143-1.137 1.125 1.155-1.143 1.137-1.125-1.155zm-1.829 1.817l1.143-1.137 1.125 1.155-1.143 1.137-1.125-1.155zm3.628.03l1.143-1.137 1.125 1.155-1.143 1.137-1.125-1.155zm-5.11 1.443l.797-.792 1.125 1.155-1.457 1.448-.465-1.811zm3.281.374l1.143-1.137 1.125 1.155-1.143 1.137-1.125-1.155zm3.627.03l1.144-1.137.784.805-.494 1.803-1.433-1.472zm-5.77 2.099l1.457-1.448 1.125 1.155-.796.792-1.786-.499zm3.942-.282l1.143-1.137 1.433 1.472-1.793.47-.784-.805z'
        clipRule='evenodd'
      />
    </svg>
  </i>
);

PlaidLogo.displayName = 'PlaidLogo';
export default PlaidLogo;
